// extracted by mini-css-extract-plugin
export default {"blinking":"HeroSection_blinking__8gtKI","blink":"HeroSection_blink__548+-"};